import { ChevronLeft, ChevronRight } from 'lucide-react';

// Shared pager for list/table views. Renders nothing when there's a single page.
export default function Pagination({ page, pageCount, onPageChange, total, pageSize }) {
  if (pageCount <= 1) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pt-2" data-testid="pagination">
      <p className="text-xs text-slate-500 text-center sm:text-left">
        Mostrando {from}–{to} de {total}
      </p>
      <div className="flex items-center justify-between sm:justify-end gap-2 min-w-0">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="hit-44 flex items-center justify-center gap-1 h-9 px-3 rounded-xl text-sm font-medium bg-slate-900/70 border border-white/10 text-slate-300 hover:bg-white/5 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          data-testid="pagination-prev"
        >
          <ChevronLeft className="w-4 h-4 shrink-0" /> Anterior
        </button>
        <span className="text-xs text-slate-400 tabular-nums text-center whitespace-nowrap px-1">
          {page} / {pageCount}
        </span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= pageCount}
          className="hit-44 flex items-center justify-center gap-1 h-9 px-3 rounded-xl text-sm font-medium bg-slate-900/70 border border-white/10 text-slate-300 hover:bg-white/5 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          data-testid="pagination-next"
        >
          Siguiente <ChevronRight className="w-4 h-4 shrink-0" />
        </button>
      </div>
    </div>
  );
}
